import React from 'react';
import {StyleSheet} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';

const MenuDivider = ({marginTop, style}) => (
  <LinearGradient
    start={{x: 0, y: 1}}
    end={{x: 0, y: 0}}
    locations={[0, 1]}
    colors={['#577189', '#526c84']}
    style={[styles.divider, {marginTop}, style]}
  />
);

const styles = StyleSheet.create({
  divider: {
    height: 1,
    width: '70%',
    alignSelf: 'center',
    backgroundColor: '#778fa5'
  }
});

export default MenuDivider;
